import * as React from "react";
import { Alert, Badge, Text } from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons-react";

function FormSubmitError({ error }: { error: string }) {
  if (error) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "5px",
        }}
        data-testid="error"
      >
        <Badge mr="xs" radius="xs" color={"red"} variant="light">
          Error
        </Badge>
        <Text fs="italic" size="sm">
          {error}
        </Text>
        {/*         <Alert icon={<IconAlertCircle size={16} />} title={"Error"} color="red">
          {error}
        </Alert> */}
      </div>
    );
  }
  return <></>;
}

export default FormSubmitError;
